import React, {FunctionComponent} from "react";
import {BackgroundShape} from "../backgroundShape/backgroundShape.component";
import {OpenSiteTopCard} from "../../interfaces/strapi";
import {DialogButton} from "../dialogButton";
const styles = require("./topCard.component.scss");

export const TopCard: FunctionComponent<OpenSiteTopCard> = props => {
    const {title, description, subtitle, horizontalTopCard, bigContent, reverseCard, ctaText, modalType,
        backgroundShape, sectionPadding, topCardContent} = props;
    return (
        <div className={styles.cardBackground}>
            {!!backgroundShape &&
                <BackgroundShape {...backgroundShape} />
            }
            <div className={`${styles.cardWrapper} ${horizontalTopCard ? styles.horizontal : styles.vertical}
            ${reverseCard ? styles.reverse : ''} ${sectionPadding ? styles[sectionPadding] : ''} ${bigContent ? styles.bigContent : ''}`}>
                <div className={styles.container}>
                    <div className={styles.topCardTextContainer}>
                        <div className={styles.topCardText}>
                            <h1>
                                {title}
                            </h1>
                            <div className={styles.topCardSubTitle}>
                                {description ? description : subtitle}
                            </div>
                            {ctaText &&
                                <div className={styles.demoButtonContainer}>
                                <DialogButton text={ctaText} modalType={modalType}/>
                            </div>}
                        </div>
                    </div>
                    <div className={styles.topCardContent}>
                        {topCardContent}
                    </div>
                </div>
            </div>
        </div>
);
};
